import React, { PropTypes } from "react";
import { ControlLabel, FormGroup } from "react-bootstrap";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { FormattedMessage } from "react-intl";

const Autocomplete = (props, context) => {
  const {
    emptyLabel,
    filterBy,
    groupClassName,
    id,
    input,
    isLoading,
    label,
    labelKey,
    minLength,
    onChange: propsOnChange,
    onSearch,
    options,
    placeholder,
    promptText,
    renderItems,
    searchText,
  } = props;
  const scene = context.scene ? "-" + context.scene : "";

  const onChange = (selection) => {
    const emulatedEvent = {
      target: {
        value: selection,
        name: input.name,
      },
    };
    propsOnChange && propsOnChange(emulatedEvent);
    return input.onChange(selection);
  };

  return (
    <FormGroup className={groupClassName} controlId={id + scene}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="input-wrapper">
        <AsyncTypeahead
          emptyLabel={emptyLabel}
          filterBy={filterBy}
          id={id}
          isLoading={isLoading}
          labelKey={labelKey}
          minLength={minLength}
          onChange={onChange}
          onSearch={onSearch}
          options={options}
          placeholder={placeholder}
          promptText={promptText}
          renderMenuItemChildren={renderItems}
          searchText={searchText}
        />
      </div>
    </FormGroup>
  );
};

Autocomplete.propTypes = {
  emptyLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  filterBy: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object,
  isLoading: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  labelKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  minLength: PropTypes.number,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  promptText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  renderItems: PropTypes.func.isRequired,
  searchText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

Autocomplete.defaultProps = {
  emptyLabel: <FormattedMessage id="common.filters.emptyLabel" />,
  filterBy: "name",
  isLoading: false,
  labelKey: "name",
  minLength: 3,
  onSearch: () => {},
  promptText: <FormattedMessage id="common.filters.promptText" />,
  searchText: <FormattedMessage id="common.filters.searchText" />,
};

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/common/form/Autocomplete.js